'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Members = {

    async getAll() {
		try {
      let response = await axios.get(API_URL + '/user/members', await getHeader());

			return response.data;

		} catch(error) {
      return false;
		}
    },
    
    async update(firebaseID, name, displayName, phoneNumber) {
      try {
        if (!firebaseID || !name || !displayName) {
          return { error: 'Mandatory Field Missing.' };
        }

        let response = await axios.patch(API_URL + '/user/' + firebaseID, {
            "name": name,
            "displayName": displayName,
            "phoneNumber": phoneNumber
        }, await getHeader());

        return !response.data.id ? false: response.data;

      } catch(error) {
            return false;
      }
    },
    
    async getTotalCount() {
      try {
        let header = await getHeader();
        let response = await axios.get(API_URL + '/user/countMembers', header);

        return response.data.count;

      } catch(error) {
        return false;
      }
    },

    async suspend(firebaseID) {
      try {
        let header = await getHeader();
        let response = await axios.post(API_URL + '/user/suspend/' + firebaseID, {
            "suspend": true
        }, header);

        return response.data.suspended == 1;

      } catch(error) {
        return false;
      }
    },

    async unsuspend(firebaseID) {
      try {
        let header = await getHeader();
        let response = await axios.post(API_URL + '/user/suspend/' + firebaseID, {
            "suspend": false
        }, header);

        return response.data.suspended !== 1;

      } catch(error) {
        return false;
      }
    }
    
}

export default Members;
